let location = 0;

$(function() {
    $(document).on(
        'click',
        '.react-pagination__next, .react-pagination__previous, .datatable-paging__prev, .datatable-paging__next, .datatable-paging__jump li, .react-pagination__item--page',
        function(e) {
            e.preventDefault();

            if (
                e.target.parentElement.classList.contains('datatable-paging__prev') ||
                e.target.parentElement.classList.contains('datatable-paging__next') ||
                e.target.parentElement.classList.contains('datatable-paging__jump')
            ) {
                let el = document.querySelector('[data-behaviour="react-database-hero"]');

                if (!el && document.getElementById('filters-form')) {
                    el = document.getElementById('filters-form');
                }

                location = el.offsetTop;

                let viewportWidth = window.innerWidth;
                if(viewportWidth > 1024 ) {
                    location = location - 80;
                }
                
            }

            // Scroll to different element
            if(e.target.parentElement.dataset.scrolltarget) {

                const el = e.target.parentElement.dataset.scrolltarget;
                location = document.querySelector(el).offsetTop;
                let viewportWidth = window.innerWidth;
                if(viewportWidth > 1024 ) {
                    location = location - 120;
                }
            }

            requestAnimationFrame(initialScrollPosition);
            
        },
    );
});   

function initialScrollPosition() {
    scroll({ top: location, behavior: 'smooth' });
}
